<template>
  <div id="details" ref="details"></div>
</template>

<script>
import Quill from 'quill';

export default {
  props: {
    details: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.editor = new Quill(this.$refs.details, {
      readOnly: true,
      theme: false
    });

    if (this.details.length) {
      this.editor.setContents(JSON.parse(this.details), 'silent');
    }
  }
}
</script>
